<button
  class="sm-context-menu-item"
  [class.sm-context-menu-item--tone-none]="item.tone === 'none'"
  [class.sm-context-menu-item--tone-viewer]="item.tone === 'viewer'"
  [class.sm-context-menu-item--tone-editor]="item.tone === 'editor'"
  [class.sm-context-menu-item--selected]="item.selected"
  [class.sm-context-menu-item--checked]="item.checked"
  type="button"
  [attr.role]="selectionStyle === 'radio' ? 'menuitemradio' : 'menuitem'"
  [attr.aria-checked]="selectionStyle === 'radio' ? (item.checked ?? item.selected ?? false) : null"
  [attr.aria-label]="item.ariaLabel || (item.ariaLabelKey ? (item.ariaLabelKey | translate) : null)"
  [attr.title]="item.ariaLabel || (item.ariaLabelKey ? (item.ariaLabelKey | translate) : null)"
  [disabled]="item.disabled"
  (click)="handleClick()">
  @if (item.iconSrc || item.iconName || item.icon) {
    <span class="sm-context-menu-item__leading">
      @if (item.icon) {
        <ion-icon class="sm-context-menu-item__icon" [icon]="item.icon" [style.color]="item.iconColor" aria-hidden="true" />
      } @else if (item.iconSrc) {
        <img class="sm-context-menu-item__image" [src]="item.iconSrc" [alt]="item.iconAlt || ''">
      } @else if (item.iconName && item.leadingIconVisible !== false) {
        <ion-icon class="sm-context-menu-item__icon" [class.favorite-star]="item.id === 'favorite'" [name]="item.iconName" aria-hidden="true"></ion-icon>
      } @else {
        <span class="sm-context-menu-item__icon-placeholder" aria-hidden="true"></span>
      }
    </span>
  }

  <span class="sm-context-menu-item__text">{{ item.text || (item.textKey | translate) }}</span>

  @if (item.showTrailingCheck !== false && (item.checked || item.selected)) {
    <span class="sm-context-menu-item__trailing">
      <ion-icon class="sm-context-menu-item__check" name="checkmark-outline" aria-hidden="true"></ion-icon>
    </span>
  }
</button>
